export const hasExhaustedPaidPlays = (plan: { status: string; clicks_restantes: number; excess_clicks: number } | null) =>
  plan?.status === 'active' && Number.isFinite(plan.clicks_restantes) && plan.clicks_restantes <= 0 &&
  Number.isFinite(plan.excess_clicks) && plan.excess_clicks <= 0;
